import { RuleType } from "./types";

export const RULE_ROOTS: Record<RuleType, string> = {
  MPPR: "payer-rules",
  CASE_RATE: "pricing/caseRateRuleset",
  PACKAGE: "package-rulesets",
  EXPLODING_FEE: "exploding-fee-schedules",
  INPATIENT: "inpatient-rulesets",
};

type RuleTagType =
  | "MpprRulesets"
  | "CaseRateRulesets"
  | "PackageRulesets"
  | "ExplodingFeeScheduleRulesets"
  | "InpatientRulesets";

export const RULE_TAG: Record<RuleType, RuleTagType> = {
  MPPR: "MpprRulesets",
  CASE_RATE: "CaseRateRulesets",
  PACKAGE: "PackageRulesets",
  EXPLODING_FEE: "ExplodingFeeScheduleRulesets",
  INPATIENT: "InpatientRulesets",
};

export const MAX_CONTRACT_LANGUAGE_LENGTH = 10000;
export const MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024;
export const MAX_ATTACHMENTS_PER_RULE = 25;
export const ALLOWED_ATTACHMENT_EXTENSIONS =
  ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.rtf,.png,.jpg,.jpeg,.gif,.tif,.tiff,.bmp,.webp,.ppt,.pptx,.odt,.ods,.odp,.zip";
